import React from "react";
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import Footer from "../components/Footer";
import NewsArticle from "../components/NewsArticle";

const NewsDetailsPage = () => <Layout pageTitle="HiTech | Chi tiết tin tức"><NavOne /><NewsArticle /><Footer /></Layout>;

export default NewsDetailsPage;
